import { StateUtils } from '@spartacus/core';

export function isStableSelector<T>(state: StateUtils.ProcessesLoaderState<T>): boolean {
  return state.processesCount === 0 && !state.loading;
}

export function hasPendingProcessesSelector<T>(state: StateUtils.ProcessesLoaderState<T>): boolean {
  return state.processesCount > 0;
}
